export default "__VITE_ASSET__DNBwP5Ad__"